// removed by extract-text-webpack-plugin
module.exports = {"wolf":"#dcdee2","headerHeight":"60px","this":"AppLayoutContentViewHeader__this___3ynwu","header":"AppLayoutContentViewHeader__header___2MbgI","title":"AppLayoutContentViewHeader__title___Suwnv","previousButton":"AppLayoutContentViewHeader__previousButton___1qyYa","children":"AppLayoutContentViewHeader__children___2yEOg"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/styles/AppLayoutContentViewHeader.css
// module id = 2583
// module chunks = 0 1